import useStyles from 'hooks/useStyles'
import styles from './Theme1.module.scss'

const Theme1 = () => {
  useStyles(styles)
  return null
}

export default Theme1
